import * as z from "zod";

export const acceptMerchantCarrierFeeTerms = {
  name: "acceptMerchantCarrierFeeTerms" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
